var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-card', [_c('b-card-header', [_c('b-card-title', [_vm._v("Super Admin Profile")])], 1), _c('b-card-body', [_c('b-form', {
    on: {
      "submit": function submit($event) {
        $event.preventDefault();
        return _vm.updateProfile($event);
      }
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Name",
      "label-for": "name"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "name",
      "type": "text",
      "state": _vm.nameState,
      "required": ""
    },
    model: {
      value: _vm.profile.name,
      callback: function callback($$v) {
        _vm.$set(_vm.profile, "name", $$v);
      },
      expression: "profile.name"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" Name must be at least 3 characters long ")])], 1), _c('b-form-group', {
    attrs: {
      "label": "Email",
      "label-for": "email"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "email",
      "type": "email",
      "disabled": ""
    },
    model: {
      value: _vm.profile.email,
      callback: function callback($$v) {
        _vm.$set(_vm.profile, "email", $$v);
      },
      expression: "profile.email"
    }
  }), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Email cannot be changed")])], 1), _c('b-form-group', {
    attrs: {
      "label": "Password",
      "label-for": "password"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password",
      "type": "password",
      "state": _vm.passwordState,
      "placeholder": "Leave blank if not changing"
    },
    model: {
      value: _vm.profile.password,
      callback: function callback($$v) {
        _vm.$set(_vm.profile, "password", $$v);
      },
      expression: "profile.password"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" Password must be at least 6 characters ")])], 1), _c('b-form-group', {
    attrs: {
      "label": "Confirm Password",
      "label-for": "password_confirmation"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "password_confirmation",
      "type": "password",
      "state": _vm.confirmPasswordState,
      "placeholder": "Leave blank if not changing"
    },
    model: {
      value: _vm.profile.password_confirmation,
      callback: function callback($$v) {
        _vm.$set(_vm.profile, "password_confirmation", $$v);
      },
      expression: "profile.password_confirmation"
    }
  }), _c('b-form-invalid-feedback', [_vm._v(" Password confirmation does not match ")])], 1), _c('div', {
    staticClass: "d-flex justify-content-end"
  }, [_c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary",
      "disabled": _vm.loading || !_vm.formValid
    }
  }, [_vm._v(" " + _vm._s(_vm.loading ? "Updating..." : "Update Profile") + " ")])], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }